import PropTypes from 'prop-types';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Colors } from '../../../constants/colors.constants';
import { WarningNewIcon } from '../../../icons';
import ButtonSystem from '../../DesignSystem/ButtonSystem';
import ModalSystem from '../../DesignSystem/ModalSystem';
import { mismatchedMessageWithLink } from '../utils/knowledgebaseUtils';
import { trackCalendarModalEvents } from '../CalendarEdit/utils';

const { YELLOW } = Colors;

export default function ShiftWarningModal({ handleShowModal, handleSave }) {
  const { t } = useTranslation();

  return (
    <ModalSystem
      width={400}
      visible={true}
      setVisible={handleShowModal}
      theme="dark"
      showTitle={false}
      showIconTitle={false}
      onCancelFunction={() => handleShowModal(false)}>
      <div className="shiftWarningModal">
        <WarningNewIcon color={YELLOW} size={48} />
        <div className="shiftWarningModal-text">
          <p>{mismatchedMessageWithLink({ t, source: 'edition' })}</p>
          <p>{t('master_plan_calendars.adjust')}</p>
        </div>
        <div className="shiftWarningModal-buttons">
          <ButtonSystem
            type="secondary"
            onClick={() => {
              trackCalendarModalEvents('Save Anyway');
              handleSave();
            }}>
            {t('master_plan_calendars.save_anyway')}
          </ButtonSystem>
          <ButtonSystem
            onClick={() => {
              trackCalendarModalEvents('Continue Editing');
              handleShowModal(false);
            }}>
            {t('master_plan_calendars.continue_editing')}
          </ButtonSystem>
        </div>
      </div>
    </ModalSystem>
  );
}

ShiftWarningModal.propTypes = {
  handleShowModal: PropTypes.func.isRequired,
  handleSave: PropTypes.func.isRequired
};
